import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import SearchId from './SearchId.js';
import SearchPassword from './SearchPassword.js';

const SearchView = () => {
  const history = useHistory();

  return (
    <TopLevelWrapper>
      <TitleWrapper onClick={() => history.push('/login')}>
        <Logo src='https://picture.link-zone.org/ZoneLogo.png'/>
        <Title>LINKO ZONE</Title>
      </TitleWrapper>
      <InfoBoxWrapper>
        <SearchId/>
        <SearchPassword/>
      </InfoBoxWrapper>
    </TopLevelWrapper>
  );
}

export default SearchView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  max-width: 1200px;

  @media (max-width: 1164px) {
    width: auto;
    max-width: none;
    align-items: flex-start;
    margin-top: 42px;
    margin-bottom: 102px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 345px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Logo = styled.img`
  width: 78px;
  height: 78px;

  margin-right: 15px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 35px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 40px;

  width: 100%;

  @media (max-width: 1164px) {
    flex-direction: column;
    align-items: flex-start;
    width: auto;
    margin-top: 20px;
    gap: 24px;
  }
`;
